// extracted by mini-css-extract-plugin
module.exports = {"mobile":"360","tablet":"768","desktop":"1280","closeButton":"BvnjV","closeIcon":"_2U8gI"};